import React from 'react';
import { Link } from 'react-router-dom';

import { PLANS_URL } from '../sandboxLinks';

export function PricingButton() {
  return (
    <Link
      className="tour-guide-launcher tour-guide-launcher--plans"
      to={PLANS_URL}
      data-testid="pricing-button"
      aria-label="See plans and pricing"
    >
      <svg
        className="tour-guide-launcher__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V4a2 2 0 0 1 2-2h8l8.59 8.59a2 2 0 0 1 0 2.82Z" />
        <line x1="7" y1="7" x2="7.01" y2="7" />
      </svg>
      <span className="tour-guide-launcher__label">Plans</span>
    </Link>
  );
}
